// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"4c9d97a6","324":"c2fda818","453":"03346f77","694":"161f3d77"}[chunkId] + ".chunk.js";
};